<!-- TODO: use templates for fields -->
<div class="great-white">
  <div class="cssload-container" *ngIf="isLoading">
    <div class="cssload-speeding-wheel"></div>
  </div>
  <div class="content-row">
    <div class="left-column">
      <div class="name-group">
        <div class="client">
          <div class="label">{{ 'auth.createProject.client' | translate }}</div>
          <!-- <div class="label">*{{clientLabel}}</div> -->
          <input
            focusSelect
            autofocus
            id="projectClient"
            tabindex="0"
            value="{{ project.client }}"
            (input)="onInputClient($event)"
          />
        </div>
        <div class="client">
          <div
            class="billing clickable"
            tabindex="0"
            role="button"
            enterPress="toggleBilling()"
            (keydown.enter)="toggleBilling()"
            (click)="toggleBilling()"
          >
            <div class="checkbox">
              <div *ngIf="!isDifferentBilling" class="unchecked"></div>
              <img
                *ngIf="isDifferentBilling"
                src="assets/checkmark-square-black-in-green.svg"
              />
            </div>
            <div class="label">
              {{ 'auth.createProject.differentBillingCompany' | translate }}
            </div>
          </div>
          <input
            [disabled]="!isDifferentBilling"
            [class.disabled]="!isDifferentBilling"
            focusSelect
            tabindex="0"
            id="projectBillingCompany"
            value="{{ billingCompany }}"
            (input)="onInputBilling($event)"
          />
        </div>
        <div class="project">
          <div class="label">
            {{ 'auth.createProject.projectName' | translate }}
          </div>
          <input
            focusSelect
            tabindex="0"
            id="projectName"
            value="{{ project.name }}"
            (input)="onInputName($event)"
          />
        </div>
      </div>
      <div class="field">
        <div class="label">
          {{ 'auth.createProject.projectCode' | translate }}
        </div>
        <input
          focusSelect
          tabindex="0"
          id="projectCode"
          value="{{ project.code }}"
          (input)="onInputProjectCode($event)"
        />
      </div>
      <div class="field" id="account">
        <div class="label">{{ 'auth.createProject.account' | translate }}</div>
        <div class="dropdown" tabindex="0">
          <div>{{ companyName }}</div>
          <!-- <img src="assets/arrow-down-white.svg" /> -->
        </div>
        <!-- <ops-dropdown
          id="dropdown-account"
          parentId="account"
          [options]="accountOptions"
          [isMultiSelect]="false"
          [startingFocusIndex]="0"
          uncheckedImg="assets/radio-white-unchecked.svg"
          checkedImg="assets/radio-white-checked.svg"
          (valueSelected)="onSelectAccount($event)"
          [selectedValues]="[companyName]"
          class="dropdown-component"
        ></ops-dropdown> -->
      </div>
      <div class="field scope-field">
        <div class="scope-box" *ngFor="let scope of projectScopeOptions"
        tabindex="0"
        role="button"
        (click)="onToggleScope(scope)"
        enterPress="onToggleScope(scope)"
        (keydown.enter)="onToggleScope(scope)"
        (keydown)="onToggleScope(scope)"
        >
          <div class="checkbox">
            <img
              src="/assets/checkmark-square-black-in-green.svg"
              *ngIf="project.scope.includes(scope)"
            />
          </div>
          <div class="label">{{ scope | translate }}</div>
          </div>
      </div>
      <div class="field dropdown" id="budgetType">
        <div class="label clickable" (click)="openModal('dropdown-budgetType')">
          {{ 'auth.createProject.budgetType' | translate }}
        </div>
        <div
          class="dropdown clickable"
          tabindex="0"
          role="button"
          enterPress="openModal('dropdown-budgetType')"
          (keydown.enter)="openModal('dropdown-budgetType')"
          (click)="openModal('dropdown-budgetType')"
          (keydown)="keyPressAction($event, 'dropdown-budgetType')"
        >
          <div>{{ project.budgetType }}</div>
          <img src="assets/arrow-down-white.svg" />
        </div>
        <ops-dropdown
          id="dropdown-budgetType"
          parentId="budgetType"
          [isMultiSelect]="false"
          [options]="budgetTypeOptions"
          uncheckedImg="assets/radio-white-unchecked.svg"
          checkedImg="assets/radio-white-checked.svg"
          [startingFocusIndex]="20"
          (valueSelected)="onSelectBudgetType($event)"
          class="dropdown-component"
        ></ops-dropdown>
      </div>
      <div class="field dropdown" id="projectJob">
        <div class="label clickable" (click)="openModal('dropdown-projectJob')">
          {{ 'auth.createProject.projectJob' | translate }}
        </div>
        <div
          class="dropdown clickable"
          tabindex="0"
          role="button"
          enterPress="openModal('dropdown-projectJob')"
          (keydown.enter)="openModal('dropdown-projectJob')"
          (click)="openModal('dropdown-projectJob')"
          (keydown)="keyPressAction($event, 'dropdown-projectJob')"
        >
          <div>{{ project.projectJob | translate }}</div>
          <img src="assets/arrow-down-white.svg" />
        </div>
        <ops-dropdown
          id="dropdown-projectJob"
          parentId="projectJob"
          [isMultiSelect]="false"
          [options]="projectJobOptions"
          uncheckedImg="assets/radio-white-unchecked.svg"
          checkedImg="assets/radio-white-checked.svg"
          [startingFocusIndex]="40"
          (valueSelected)="onSelectprojectJob($event)"
          class="dropdown-component"
        ></ops-dropdown>
      </div>
      <div class="multiselection-area">
        <div
          class="field dropdown"
          id="service"
          [class.square-bottom-border]="project.service?.length > 0"
        >
          <div class="label clickable" (click)="openModal('dropdown-service')">
            {{ 'auth.createProject.service' | translate }}
          </div>
          <div
            class="dropdown clickable"
            tabindex="0"
            role="button"
            enterPress="openModal('dropdown-service')"
            (keydown.enter)="openModal('dropdown-service')"
            (click)="openModal('dropdown-service')"
            (keydown)="keyPressAction($event, 'dropdown-service')"
          >
            <div></div>
            <img src="assets/arrow-down-white.svg" />
          </div>
          <ops-dropdown
            id="dropdown-service"
            parentId="service"
            [isMultiSelect]="true"
            [options]="serviceOptions"
            uncheckedImg="assets/checkbox-multi-white.svg"
            checkedImg="assets/checkbox-multi-white-active.svg"
            [startingFocusIndex]="60"
            (valueSelected)="onSelectService($event)"
            class="dropdown-component"
          >
          </ops-dropdown>
        </div>
        <div
          class="selection-display"
          [class.padding-bottom]="project.service?.length > 0"
        >
          <div
            class="multiselected-value"
            *ngFor="let value of project.service"
          >
            {{ value | translate }}
          </div>
        </div>
      </div>
    </div>
    <div class="right-column">
      <div class="field dropdown not-selectable">
        <div class="label">
          {{ 'auth.createProject.projectCurrency' | translate }}
        </div>
        <div class="dropdown not-selectable">
          <div>{{ companyBaseCurrency }}</div>
        </div>
      </div>

      <div class="field dropdown" id="currency">
        <div class="label clickable" (click)="openModal('dropdown-currency')">
          {{ 'auth.createProject.equivalentCurrency' | translate }}
        </div>
        <div
          class="dropdown clickable"
          (click)="openModal('dropdown-currency')"
          tabindex="0"
          role="button"
          enterPress="openModal('dropdown-currency')"
          (keydown.enter)="openModal('dropdown-currency')"
          (keydown)="keyPressAction($event, 'dropdown-currency')"
        >
          <div>{{ project.equivalentCurrency || ('auth.createProject.selectCurrency' | translate) }}</div>
          <img src="assets/arrow-down-white.svg" />
        </div>
        <ops-dropdown
          id="dropdown-currency"
          parentId="currency"
          [isMultiSelect]="false"
          [options]="currencyOptions"
          uncheckedImg="assets/radio-white-unchecked.svg"
          checkedImg="assets/radio-white-checked.svg"
          [startingFocusIndex]="106"
          (valueSelected)="onSelectCurrency($event)"
          class="dropdown-component"
        >
        </ops-dropdown>
      </div>


      <div class="field" [class.disabled]="!project.equivalentCurrency">
        <div class="label">
          {{ 'auth.createProject.exchangeRate' | translate }}
        </div>
        <ops-numeric-input
          class="exchange-rate-input"
          [align]="'center'"
          [value]="project.currencyRate"
          [isValueHidden]="!project.equivalentCurrency"
          [decimal]="4"
          (onValueChange)="onInputCurrencyRate($event)"
        ></ops-numeric-input>
      </div>

      <div class="field dropdown" id="marketSegment">
        <div
          class="label clickable"
          (click)="openModal('dropdown-marketSegment')"
        >
          {{ 'auth.createProject.marketSegment' | translate }}
        </div>
        <div
          class="dropdown clickable"
          (click)="openModal('dropdown-marketSegment')"
          tabindex="0"
          role="button"
          enterPress="openModal('dropdown-marketSegment')"
          (keydown.enter)="openModal('dropdown-marketSegment')"
          (keydown)="keyPressAction($event, 'dropdown-marketSegment')"
        >
          <div>{{ project.marketSegment | translate }}</div>
          <img src="assets/arrow-down-white.svg" />
        </div>
        <ops-dropdown
          id="dropdown-marketSegment"
          parentId="marketSegment"
          [isMultiSelect]="false"
          [options]="marketSegmentOptions"
          uncheckedImg="assets/radio-white-unchecked.svg"
          checkedImg="assets/radio-white-checked.svg"
          [startingFocusIndex]="80"
          (valueSelected)="onSelectMarketSegment($event)"
          class="dropdown-component"
        >
        </ops-dropdown>
      </div>

      <!-- <div class="field">
        <div class="label">
          {{ 'auth.createProject.expectedBudget' | translate }}
        </div>
        <input
          opsNumber
          value="{{ expectedBudget }}"
          tabindex="0"
          (keyup)="onInputExpectedBudget($event)"
        />
      </div> -->
      <div class="multiselection-area">
        <div
          id="preparationDates"
          class="field"
          [class.square-bottom-border]="project.preparationDates?.length > 0"
        >
          <div
            class="label clickable"
            (click)="openModal('date-picker-preparationDates')"
          >
            {{ 'auth.createProject.prepDates' | translate }}
          </div>
          <div
            class="date-dropdown clickable"
            (click)="openModal('date-picker-preparationDates')"
            tabindex="0"
            role="button"
            enterPress="openModal('date-picker-preparationDates')"
            (keydown.enter)="openModal('date-picker-preparationDates')"
            (keydown)="keyPressAction($event, 'date-picker-preparationDates')"
          >
            <img src="assets/arrow-down-white.svg" />
          </div>
          <ops-date-picker
            parentId="preparationDates"
            [isMultiSelect]="true"
            id="date-picker-preparationDates"
            [startingFocusIndex]="200"
            [selectedDates]="project.preparationDates"
            (datesSelected)="onTogglePreparationDate($event)"
          ></ops-date-picker>
        </div>
        <div
          class="selection-display"
          [class.padding-bottom]="project.preparationDates?.length > 0"
        >
          <div
            class="multiselected-value"
            *ngFor="let value of project.preparationDates"
          >
            {{ value | date : 'dd.MM.yyyy' }}
          </div>
        </div>
      </div>
      <div class="multiselection-area">
        <div
          class="field"
          id="shootingDates"
          [class.square-bottom-border]="project.shootingDates?.length > 0"
        >
          <div
            class="label clickable"
            (click)="openModal('date-picker-shootingDates')"
          >
            {{ 'auth.createProject.jobDates' | translate }}
          </div>
          <div
            class="date-dropdown clickable"
            (click)="openModal('date-picker-shootingDates')"
            tabindex="0"
            role="button"
            enterPress="openModal('date-picker-shootingDates')"
            (keydown.enter)="openModal('date-picker-shootingDates')"
            (keydown)="keyPressAction($event, 'date-picker-shootingDates')"
          >
            <img src="assets/arrow-down-white.svg" />
          </div>
          <ops-date-picker
            parentId="shootingDates"
            id="date-picker-shootingDates"
            [isMultiSelect]="true"
            [startingFocusIndex]="100"
            [selectedDates]="project.shootingDates"
            (datesSelected)="onToggleProjectDate($event)"
          ></ops-date-picker>
        </div>
        <div
          class="selection-display"
          [class.padding-bottom]="project.shootingDates?.length > 0"
        >
          <div
            class="multiselected-value"
            *ngFor="let value of project.shootingDates"
          >
            {{ value | date : 'dd.MM.yyyy' }}
          </div>
        </div>
      </div>

      <div class="field">
        <div class="label">
          {{ 'auth.createProject.preparationDays' | translate }}
        </div>
        <div class="text">{{ project.preparationDates?.length }}</div>
      </div>
      <div class="field">
        <div class="label">{{ 'auth.createProject.jobDays' | translate }}</div>
        <div class="text">{{ project.shootingDates?.length }}</div>
      </div>
    </div>
  </div>
  <div class="button-row">
    <div
      class="cancel-btn"
      tabindex="0"
      role="button"
      enterPress="onCancel()"
      (keydown.enter)="onCancel()"
      (click)="onCancel()"
    >
      {{ 'auth.createProject.cancel' | translate }}
    </div>
    <div
      class="save-btn"
      tabindex="0"
      role="button"
      enterPress="onSaveProject(false)"
      (keydown.enter)="onSaveProject(false)"
      (click)="onSaveProject(false)"
      [class.disabled]="
        isSavingInProgress ||
        !!!project.name ||
        !!!project.code ||
        !!!project.company ||
        (isDifferentBilling && !!!billingCompany)
      "
    >
      {{ 'auth.createProject.saveProject' | translate }}
    </div>
    <div
      class="continue-btn"
      tabindex="0"
      role="button"
      enterPress="onSaveProject(true)"
      (keydown.enter)="onSaveProject(true)"
      (click)="onSaveProject(true)"
      [class.disabled]="
        isSavingInProgress ||
        !!!project.name ||
        !!!project.code ||
        !!!project.company ||
        (isDifferentBilling && !!!billingCompany)
      "
    >
      {{ 'auth.createProject.saveAndContinue' | translate }}
    </div>
  </div>
</div>

<!-- Custom Currency Modal -->
<ops-custom-currency-modal
  [isVisible]="showCustomCurrencyForm"
  [config]="customCurrencyConfig"
  (currencyAdded)="onCustomCurrencyAdded($event)"
  (modalClosed)="onCustomCurrencyModalClosed()"
></ops-custom-currency-modal>
